var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "new-trip-container" },
    [
      _c("bag-price-widget-header"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "radio-button-container" },
        [
          _c("f9radio", {
            attrs: {
              name: "tripTypes",
              label: "Roundtrip",
              value: _vm.tripType,
              "input-emit-change": ""
            },
            on: { change: _vm.updateTripType }
          }),
          _vm._v(" "),
          _c("f9radio", {
            attrs: {
              name: "tripTypes",
              label: "One Way",
              value: _vm.tripType,
              "input-emit-change": ""
            },
            on: { change: _vm.updateTripType }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "form",
        { staticClass: "new-trip-form" },
        [
          _c(
            "div",
            { staticClass: "form-inputs" },
            [
              _c(
                "f9field2",
                { staticClass: "new-trip-field" },
                [
                  _c(
                    "span",
                    {
                      staticClass: "new-trip-label",
                      attrs: { slot: "label" },
                      slot: "label"
                    },
                    [_vm._v("From *")]
                  ),
                  _vm._v(" "),
                  _c("f9select2", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    ref: "origin",
                    staticClass: "new-trip-input",
                    attrs: {
                      name: "from_station",
                      autocomplete: "off",
                      "data-vv-validate-on": "",
                      "data-vv-scope": _vm.validationScope,
                      items: _vm.originStationsSorted,
                      loading: _vm.retrievingOrigins
                    },
                    on: {
                      change: function($event) {
                        _vm.$refs.destination.focus()
                      }
                    },
                    model: {
                      value: _vm.value.origin,
                      callback: function($$v) {
                        _vm.$set(_vm.value, "origin", $$v)
                      },
                      expression: "value.origin"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "f9field2",
                { staticClass: "new-trip-field" },
                [
                  _c(
                    "span",
                    {
                      staticClass: "new-trip-label",
                      attrs: { slot: "label" },
                      slot: "label"
                    },
                    [_vm._v("To *")]
                  ),
                  _vm._v(" "),
                  _c("f9select2", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "required",
                        expression: "'required'"
                      }
                    ],
                    ref: "destination",
                    staticClass: "new-trip-input",
                    attrs: {
                      name: "to_station",
                      autocomplete: "off",
                      "data-vv-validate-on": "",
                      "data-vv-scope": _vm.validationScope,
                      items: _vm.destinationStationsSorted,
                      loading: _vm.retrievingDestinations,
                      disabled: !_vm.value.origin
                    },
                    model: {
                      value: _vm.value.destination,
                      callback: function($$v) {
                        _vm.$set(_vm.value, "destination", $$v)
                      },
                      expression: "value.destination"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "f9field2",
                { staticClass: "new-trip-field" },
                [
                  _c(
                    "span",
                    {
                      staticClass: "new-trip-label",
                      attrs: { slot: "label" },
                      slot: "label"
                    },
                    [_vm._v("Depart Date *")]
                  ),
                  _vm._v(" "),
                  _c("f9date2", {
                    ref: "departDate",
                    staticClass: "new-trip-input",
                    attrs: {
                      disabled: !_vm.value.destination,
                      name: "depart_date",
                      format: _vm.dateFormatString,
                      autocomplete: "off",
                      required: true,
                      "validation-scope": _vm.validationScope,
                      "open-date": _vm.departOpenDate,
                      "min-date": _vm.minDate,
                      "max-date": _vm.originMaxDate,
                      "validate-on-change": _vm.validateOnChange,
                      "disable-dates": _vm.originDisabledDates,
                      loading: _vm.retrievingDepartureDate
                    },
                    on: { change: _vm.setReturnOpenDate },
                    model: {
                      value: _vm.value.departDate,
                      callback: function($$v) {
                        _vm.$set(_vm.value, "departDate", $$v)
                      },
                      expression: "value.departDate"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.tripType != "One Way"
                ? _c(
                    "f9field2",
                    { staticClass: "new-trip-field" },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "new-trip-label",
                          attrs: { slot: "label" },
                          slot: "label"
                        },
                        [_vm._v("Return Date *")]
                      ),
                      _vm._v(" "),
                      _c("f9date2", {
                        ref: "returnDate",
                        staticClass: "new-trip-input",
                        attrs: {
                          name: "return_date",
                          format: _vm.dateFormatString,
                          autocomplete: "off",
                          required: true,
                          "validation-scope": _vm.validationScope,
                          "open-date": _vm.returnOpenDate,
                          disabled: !_vm.value.departDate,
                          "min-date": _vm.value.departDate,
                          "max-date": _vm.destinationMaxDate,
                          "disable-dates": _vm.destinationDisabledDates,
                          loading: _vm.retrievingReturnDate,
                          "validate-on-change": _vm.validateOnChange
                        },
                        model: {
                          value: _vm.value.returnDate,
                          callback: function($$v) {
                            _vm.$set(_vm.value, "returnDate", $$v)
                          },
                          expression: "value.returnDate"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "f9field2",
                { staticClass: "new-trip-field" },
                [
                  _c(
                    "span",
                    {
                      staticClass: "new-trip-label",
                      attrs: { slot: "label" },
                      slot: "label"
                    },
                    [_vm._v("Travelers *")]
                  ),
                  _vm._v(" "),
                  _c("f9passenger-picker", {
                    ref: "passengers",
                    model: {
                      value: _vm.value.passengers,
                      callback: function($$v) {
                        _vm.$set(_vm.value, "passengers", $$v)
                      },
                      expression: "value.passengers"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "f9field2",
                { staticClass: "new-trip-field" },
                [
                  _c(
                    "span",
                    {
                      staticClass: "new-trip-label",
                      attrs: { slot: "label" },
                      slot: "label"
                    },
                    [_vm._v("Currency")]
                  ),
                  _vm._v(" "),
                  _c("f9select2", {
                    ref: "currency",
                    staticClass: "new-trip-input",
                    attrs: {
                      name: "currency",
                      type: "text",
                      autocomplete: "off",
                      "data-vv-scope": _vm.validationScope,
                      items: _vm.currencyOptions
                    },
                    nativeOn: {
                      focusin: function($event) {
                        _vm.$refs.passengers.close()
                      }
                    },
                    model: {
                      value: _vm.value.currency,
                      callback: function($$v) {
                        _vm.$set(_vm.value, "currency", $$v)
                      },
                      expression: "value.currency"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("f9field2", { staticClass: "new-trip-checkbox-field" }, [
                _c(
                  "div",
                  { staticClass: "new-trip-checkbox-container" },
                  [
                    _c("f9checkbox2", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: { tcs_checked: "receive bag prices" },
                          expression: "{ tcs_checked: 'receive bag prices' }"
                        }
                      ],
                      attrs: {
                        name: "bag_prices_terms",
                        "data-vv-scope": _vm.validationScope,
                        "aria-label":
                          "Press enter to accept the following bag price terms. I understand that if I already booked, my prices may vary from those below. The only way to get accurate\n                        pricing is to enter the flight confirmation number, or visit Manage My Booking to view prices and buy bags."
                      },
                      model: {
                        value: _vm.acceptTerms,
                        callback: function($$v) {
                          _vm.acceptTerms = $$v
                        },
                        expression: "acceptTerms"
                      }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "checkbox-text" }, [
                      _vm._v("Yes, I accept the Bag Price Terms")
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "terms-details",
                        attrs: { id: "bag-price-term-details" }
                      },
                      [
                        _vm._v(
                          "\n                        I understand that if I already booked, my prices may vary from those below. The only way to get accurate\n                        pricing is to enter the flight confirmation #, or visit “Manage My Booking” to view prices & buy bags. \n                    "
                        )
                      ]
                    )
                  ],
                  1
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "f9button2",
            {
              ref: "searchButton",
              staticClass: "new-trip-search-button",
              attrs: { name: "submit", loading: _vm.searching },
              on: { click: _vm.search }
            },
            [_vm._v("CHECK BAG PRICES")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ae128c5e", { render: render, staticRenderFns: staticRenderFns })
  }
}